/* @flow strict */

import * as React from 'react';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';

import './styles.scss';

type PropsType = {};

const RefLinksPage = ({}: PropsType): React.Element<'div'> => {
  const [url, setUrl] = React.useState('');
  const [refs, setRefs] = React.useState('');
  const [refsUrl, setRefsUrl] = React.useState([]);
  const context = React.useContext(EventDetailContainerContext);

  if (context && context.eventDetail && !_.size(url)) {
    setUrl(`${process.env.EVENT_HOST}${_.get(context, 'eventDetail.url_name')}`);
  }

  const handleGenRef = () => {
    const _refsArr = refs.split(',');
    const str = _.map(_refsArr, (s: string): string => `${url}?rn=${s.trim().replace(/\s+/g, '-')}`).join('\n');

    setRefsUrl(str);
  };

  return (
    <div className="panel panel-default panel-page">
      <div className="panel-heading panel-heading-color2">
        <div className="panel-title">
          <span>Create Referral Links</span>
        </div>
      </div>
      <div className="panel-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8 col-lg-6">
              <p>
                How many tickets sales come through Facebook? Which partner is generating the most traffic?
                Track all of it using referral links.
              </p>
              <div className="form-group">
                <label> Insert the website link for your ticket sales. </label>
                <input
                  className="form-control"
                  type="text"
                  value={url}
                  onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                    setUrl(e.target.value);
                  }}
                />
                <p className="help-block">Remember to put http:// or https://</p>
              </div>
              <div className="form-group">
                <label>Referral/Promoter names(s)</label>
                <input
                  className="form-control"
                  type="text"
                  value={refs}
                  onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                    setRefs(e.target.value);
                  }}
                />
                <p className="help-block">
                  *to generate multiple referral links, simply separate each referral name with a comma
                  (e.g. Facebook, email, newsletter, sparky)
                </p>
              </div>

              {!!_.size(refsUrl) &&
                <div className="form-group">
                  <textarea
                    readOnly
                    className="form-control"
                    rows="10"
                    value={refsUrl}
                  />
                </div>
              }

              <div className="form-group">
                <div className="pull-right">
                  <button
                    className="btn btn-pink"
                    onClick={handleGenRef}
                  >
                    generate link(s)
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefLinksPage;
